import { FC } from 'react';
import { Box, Divider, Flex, Icon, Text } from '@chakra-ui/react';

import { Clock, GiftGiving } from '../../assets';

export interface DonationStatisticsProps {
  daysLeft?: number;
  totalDonations: number;
}

export const DonationStatistics: FC<DonationStatisticsProps> = ({
  daysLeft,
  totalDonations,
}) => (
  <Flex justifyContent="space-around" width="full">
    <Flex alignItems="center" justifyContent="flex-start">
      <Box color="brand.primary.swatch1">
        <Icon as={GiftGiving} boxSize="32px" />
      </Box>
      <Box marginLeft={2} color="brand.monochromatic.900" maxW="80px">
        <Text fontSize="1.5rem" lineHeight="1">
          {totalDonations}
        </Text>
        <Text fontSize="xs">Donation(s) Received</Text>
      </Box>
    </Flex>
    {daysLeft && (
      <>
        <Divider
          orientation="vertical"
          borderColor="brand.monochromatic.200"
          h={10}
        />
        <Flex alignItems="center" justifyContent="flex-end">
          <Box color="brand.primary.swatch1">
            <Icon as={Clock} boxSize="32px" />
          </Box>
          <Box marginLeft={2} color="brand.monochromatic.900" maxW="80px">
            <Text fontSize="1.5rem" lineHeight="1">
              {daysLeft}
            </Text>
            <Text fontSize="xs">Day(s) Until Event</Text>
          </Box>
        </Flex>
      </>
    )}
  </Flex>
);
